export default class VotingBadgeRequirements {
  public points: number;
  public voteCount: number;
  public entityId: string;
  public entityType: string;
  public entityModel: any;
}
